import { useCallback } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import TwinForm from '../../../../../../forms/TwinForm'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../forms/TwinForm/types'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import withLoading from '../../../../../../utils/hoc/withLoading'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { LabelsPayload } from '../../../../../../utils/reducers/company/labels'
import { SpecificPriceRulesPayload } from '../../../../../../utils/reducers/products/specificPriceRules'
import { CustomSelectWithSearchBar } from '../../../../../../forms/CustomSelect'
import { InputHidden, InputNumberWithLabelMarginStateFull } from '../../../../../../forms/Input'
import { twinFetchPostPrinter } from '../../../../../../utils/globals/data'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import { InputTableURLsTable } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'

type ModalPrintSingleTagBuyProps = ModalEditComponentProps & ReduxModalPrintSingleTagBuy & {
    orderURLs: InputTableURLsTable
    Order: TwinDictionary
}

const ModalPrintSingleTagBuy: React.FC<ModalPrintSingleTagBuyProps> = ({ setOpened, orderURLs, labels, specificPriceRules, allRowData, ...logic }) => {
    const { loading, onPreSubmit, onSubmit } = useModalPrintSingleTagBuyLogic({ setOpened, allRowData })
    const { t } = useTwinTranslation()
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} onClickOut={false} className='flex_height skip_width_fields'>
            <TwinForm beforeSubmitHandler={onPreSubmit} action={orderURLs.printTags} onSubmit={onSubmit} className='flex flex-auto flex-col justify-between gap-10 ' triggerErrors={false} triggerSuccess={false}>
                <CustomSelectWithSearchBar items={labels || {}} label={t('tag', 'Etiqueta')} value={Object.keys(labels || {})?.[0] || ''} name='LabelId' required={true} />
                <CustomSelectWithSearchBar items={specificPriceRules?.dictionary || {}} label={t('specificPriceRule', 'Tarifa')} value={specificPriceRules?.arrSorted?.[0]?.id || ''} name='SpecificPriceRuleId' required={true} />
                <InputNumberWithLabelMarginStateFull className='tags_quantity' name='tagQuantity' label={t('numberTags', 'Número de etiquetas')} defaultValue={allRowData?.quantity} maxValue={allRowData?.quantity} minValue={1}  />
                <InputHidden name='typePrinting' value='allProducts' />
                <InputHidden name='OrderId' value={allRowData?.OrderId} />
                <ButtonsModalSmallCentered confirmText={t('print', 'Imprimir')} setOpened={() => { }} onCancel={() => setOpened(null)} loading={loading} />
            </TwinForm>
        </ModalSmallCentered>
    )
}

interface ModalPrintSingleTagBuyLogicProps {
    allRowData?: RowData
    setOpened: ModalOpenedSetTy
}

const useModalPrintSingleTagBuyLogic = ({ setOpened, allRowData }: ModalPrintSingleTagBuyLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const { t } = useTwinTranslation()
    const errorMessage = t('couldNotConnectWithPrinter', 'No se ha podido conectar con la impresora')
    const onPreSubmit: BeforeSubmitHandler = useCallback((vals) => {
        startLoading()
        if(allRowData){
            vals.selectedProductsIds = [allRowData?.id]
        }
        return true
    }, [startLoading, allRowData])

    const onSubmit: OnSubmit = useCallback(async (result) => {
        if (result && result.status === 367) {
            const body = await result.json()
            const myresult = await twinFetchPostPrinter('/printLabel', body, errorMessage)
            if (myresult) {
                setOpened(null)
            }
        }
        endLoading()
    }, [endLoading, setOpened, errorMessage])
    return { onPreSubmit, onSubmit, loading, endLoading }
}

const modalPrintSingleTagBuyDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
    setLabels: (payload: LabelsPayload) => ({ type: 'CHANGE_LABELS', payload }),
}

type ReduxModalPrintSingleTagBuy = ConnectedProps<typeof modalPrintSingleTagBuyConnect>
const mapModalPrintSingleTagBuyConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules, labels: state.labels })
const modalPrintSingleTagBuyConnect = connect(mapModalPrintSingleTagBuyConnector, modalPrintSingleTagBuyDispatch)

const modalPrintSingleTagBuyConnectLoading = withLoading(ModalPrintSingleTagBuy, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/config/label/getAllLabels', propName: 'labels', setFunctionName: 'setLabels' }])
const ModalPrintSingleTagBuyConnect = modalPrintSingleTagBuyConnect(modalPrintSingleTagBuyConnectLoading)

export default ModalPrintSingleTagBuyConnect